export default "__VITE_ASSET__B2KELAi9__"